export default "__VITE_PUBLIC_ASSET__814bb603__"